import React from "react";
import { useNavigate } from "react-router-dom";
import { Box, Button, Typography } from "@mui/material";
import HomeIcon from "@mui/icons-material/Home";
import MDTypography from "components/MDTypography";
import "../Page404/style.css";

const NotFoundPage = () => {
  const navigate = useNavigate();
  const navigateToHome = () => {
    navigate("/");
  };
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
        minHeight: "100vh",
        backgroundColor: "#fbf8f8",
      }}
    >
      <Box className="notfound">
        <div className="notfound-404">
          <h1>
            4<span>0</span>4
          </h1>
        </div>
        <h2>Trang này không tồn tại</h2>
      </Box>
      <Button
        variant="contained"
        color="primary"
        sx={{ color: "#fff" }}
        onClick={navigateToHome}
        startIcon={<HomeIcon />}
      >
        Trang chủ
      </Button>
    </Box>
  );
};

export default NotFoundPage;
